/**
 * Utility functions for formatting commission amounts
 */

/**
 * Format commission amount for display
 * @param amount - Amount in RM (e.g., 0.50)
 * @returns Formatted string (e.g., "RM 0.50")
 */
export const formatCommissionAmount = (amount: number): string => {
  return amount.toFixed(2);
};

/**
 * Format commission amount per set with context
 * @param amount - Amount in RM per set
 * @param sets - Number of sets (optional)
 * @returns Formatted string with context
 */
export const formatCommissionWithSets = (amount: number, sets?: number): string => {
  const baseFormat = formatCommissionAmount(amount);
  if (sets !== undefined && sets > 0) {
    const total = amount * sets;
    return `${baseFormat}/set × ${sets} sets = RM ${total.toFixed(2)}`;
  }
  return `${baseFormat}/set`;
};

/**
 * Parse amount input from user
 * @param value - Input string or number
 * @returns Parsed amount
 */
export const parseCommissionAmount = (value: string | number): number => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  return isNaN(num) ? 0 : Math.max(0, Math.min(num, 1.0)); // Cap at RM 1.00
};

/**
 * Format currency
 * @param value - Amount in currency
 * @returns Formatted string
 */
export const formatCurrency = (value: number): string => {
  return value.toFixed(2);
};

/**
 * Legacy function - kept for backward compatibility
 * Now just returns the amount formatted as currency
 * @deprecated Use formatCommissionAmount instead
 */
export const formatPercentage = (value: number): string => {
  return formatCommissionAmount(value);
};

